import { SmallTitle } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { LAYOUT_SPACING } from '@sleepstation/const'
import {
  backgroundColor,
  borderRadius,
  color,
  marginBottom,
  padding,
  top,
} from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.MEDIUM,
})`
  position: relative;
  ${padding([[0, 0.5, 1]])}
  ${marginBottom(0.5)}
  z-index:1;

  > * {
    position: relative;
    z-index: 1;
  }

  &::before {
    position: absolute;
    left: 0;
    right: 0;
    ${top(0.75)}
    bottom: 0;
    content: '';
    z-index: 0;
    ${borderRadius(0.75)}
    ${backgroundColor(`bodyBackground`)}
  }
`

const Body = styled.div`
  b,
  strong {
    ${color(`highlight`)}
  }
`

const TitleWrapper = styled.div`
  ${borderRadius(0.75)}
  ${padding([[0.25, 0.75]])}
  ${backgroundColor(`backgroundPrimary`)}
  align-self: flex-start;
`

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const InfoCard = ({ title, bodyAst }) => (
  <Layout>
    <TitleWrapper>
      <SmallTitle>{title}</SmallTitle>
    </TitleWrapper>
    <Body>
      <CopyRenderer htmlAst={bodyAst} />
    </Body>
  </Layout>
)

InfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  bodyAst: PropTypes.object.isRequired,
}

export default InfoCard
